import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
    selector: 'app-forgotpassword',
    templateUrl: './forgotpassword.component.html',
    styleUrls: ['./forgotpassword.component.scss'],
})
export class ForgotpasswordComponent implements OnInit {
    public forgotpwdform: FormGroup;
    languageConext: any;
    headerTitle: any;
    currentpath;
    formsubmitted: any = false;
    firstnumber: any;
    secondnumber: any;
    typedValue: any;
    validcaptcha: boolean = false;
    maxDate: any;
    dob: any;
    userId: any;
    constructor(public formBuilder: FormBuilder, private datePicker: DatePicker,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        public _sanitizer: DomSanitizer,
        public api: RestapiService) {
        this.currentpath = this.router.url;
        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].Forgotpassword;
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].Forgotpassword;
            console.log(this.languageConext)
        }
        this.headerTitle = this.languageConext.heading.text;
        this.firstnumber = Math.floor(Math.random() * 10);
        this.secondnumber = Math.floor(Math.random() * 10);

        this.forgotpwdform = formBuilder.group({
            userId: ['', Validators.required],
            dob: ['', Validators.required],
            typedValue: ['', Validators.required],
        });

    }
    ngOnInit() {
        this.maxDate = new Date().toISOString();
    }
    typeingvalue() {
        console.log(this.typedValue)
        if ((this.firstnumber + this.secondnumber) == this.typedValue) {
            this.validcaptcha = true
        }
        else {
            this.validcaptcha = false;
        }
    }

    showDatepicker() {
        if (this.dob == undefined || this.dob == null || this.dob == "") {
            let fulldate = new Date('01/01/2001');
            let mdte = new Date();
            this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
                this.dob = data;
            }, err => {
                console.log(err);
            });
        }
        else {
            let split = this.dob.split("/");
            let sdate = split[1] + "/" + split[0] + "/" + split[2]
            var d = new Date(sdate);
            let mdte = new Date();
            this.cmndef.showdatePicker(d, "", mdte).then(data => {
                this.dob = data;
            }, err => {
                console.log(err);
            });
        }
    }
    submit() {
        console.log(this.dob)
        let dobdate: any;
        if (this.cmndeclaration.cordovaSupport) {
            console.log("cordovasupport", dobdate);
            dobdate = this.dob;
        }

        else {
            console.log("not cordova support")
            dobdate = moment(this.dob).format("DD/MM/YYYY");
        }
        if (this.forgotpwdform.valid) {
            var data = {
                "requestType": "PREFORGOTPASSWORD",
                "userType": "2",
                "userType2": {
                    "dob": dobdate,
                    "userId": this.forgotpwdform.value.userId
                }
            }
            console.log(data);
            if (this.forgotpwdform.value.userId.indexOf('@') != -1) {
                data.userType2['emailId'] = this.forgotpwdform.value.userId || "";
            } else {
                data['mobileNo'] = this.forgotpwdform.value.userId || "";
                data.userType2['mobileNo'] = this.forgotpwdform.value.userId || "";
            }
            localStorage.setItem("forgotPasswordData", JSON.stringify(data));
            this.register(data);
        }
    }

    showinfo(msg) {

        this.cmndef.presentAlert("", msg, "info");
    }



    register(data) {
        this.cmndef.previousPage = this.currentpath;
        let userData = data;
        this.api.postapi("userRegistration", data).then(response => {
            if (response) {
                let userDetails = {
                    mobileNo: userData.mobileNo ? userData.mobileNo : "",
                    state: response['state'],
                    dob: userData.userType2.dob ? userData.userType2.dob : "",
                    emailId: userData.userType2.emailId ? userData.userType2.emailId : "",
                    userId: userData.mobileNo ? userData.mobileNo : (userData.userType2.emailId ? userData.userType2.emailId : "")
                }
                this.cmndeclaration.storeProcess(userDetails,"profile");
                sessionStorage.CurrentPage = "/verifyOtp"
                this.navctrl.navigateRoot('/verifyOtp');
            }


        })
    }

    validatefun(event, flag) {
        if (flag == "userId") {
            this.userId = this.userId.replace(/[^A-Za-z0-9!@#$%^&*()-+_.,'" ]/g, '')
        }
    }

}
